/**
 * Emoji name map for search. Each emoji maps to an array of lowercase search terms.
 * Only needs to cover common search terms — not an exhaustive dictionary.
 */
const EMOJI_NAMES = {
  // Smileys & People
  '😀': ['grinning', 'happy', 'smile'],
  '😃': ['smiley', 'happy', 'smile'],
  '😄': ['smile', 'happy', 'grin'],
  '😁': ['grin', 'beam', 'happy'],
  '😆': ['laughing', 'satisfied', 'lol'],
  '😅': ['sweat', 'smile', 'nervous'],
  '🤣': ['rofl', 'laughing', 'lol', 'floor'],
  '😂': ['joy', 'tears', 'laughing', 'lol', 'crying laughing'],
  '🙂': ['slightly smiling', 'smile'],
  '😊': ['blush', 'happy', 'smile'],
  '😇': ['angel', 'innocent', 'halo'],
  '🥰': ['love', 'hearts', 'adore', 'smiling hearts'],
  '😍': ['heart eyes', 'love', 'crush'],
  '🤩': ['star struck', 'excited', 'starstruck', 'wow'],
  '😘': ['kiss', 'blowing kiss', 'love'],
  '😗': ['kiss', 'kissing'],
  '😚': ['kiss', 'closed eyes'],
  '😙': ['kiss', 'smiling'],
  '🥲': ['smiling tear', 'sad smile', 'happy cry'],
  '😋': ['yummy', 'delicious', 'tongue'],
  '😛': ['tongue', 'playful'],
  '😜': ['wink', 'tongue', 'crazy', 'playful'],
  '🤪': ['zany', 'crazy', 'wild', 'goofy'],
  '😝': ['tongue', 'squinting'],
  '🤑': ['money', 'rich', 'dollar'],
  '🤗': ['hug', 'hugging', 'open hands'],
  '🤭': ['oops', 'giggle', 'hand over mouth'],
  '🫢': ['gasp', 'surprise', 'oh no'],
  '🤫': ['shh', 'quiet', 'shush', 'secret'],
  '🤔': ['thinking', 'hmm', 'wondering', 'think'],
  '🫡': ['salute', 'yes sir'],
  '🤐': ['zipper', 'quiet', 'sealed lips', 'mute'],
  '🤨': ['raised eyebrow', 'skeptical', 'sus'],
  '😐': ['neutral', 'meh', 'blank'],
  '😑': ['expressionless', 'blank', 'meh'],
  '😶': ['no mouth', 'silent', 'speechless'],
  '🫠': ['melting', 'melt', 'dissolve'],
  '😏': ['smirk', 'smug', 'flirty'],
  '😒': ['unamused', 'meh', 'annoyed'],
  '🙄': ['eye roll', 'whatever', 'annoyed'],
  '😬': ['grimace', 'awkward', 'yikes', 'cringe'],
  '😮‍💨': ['exhale', 'sigh', 'relief'],
  '🤥': ['lying', 'pinocchio', 'liar'],
  '🫨': ['shaking', 'vibrating'],
  '😌': ['relieved', 'content', 'peaceful'],
  '😔': ['pensive', 'sad', 'disappointed'],
  '😪': ['sleepy', 'tired'],
  '🤤': ['drool', 'drooling', 'yummy'],
  '😴': ['sleeping', 'zzz', 'tired', 'sleep'],
  '😷': ['mask', 'sick', 'covid', 'flu'],
  '🤒': ['thermometer', 'sick', 'fever'],
  '🤕': ['bandage', 'hurt', 'injured'],
  '🤢': ['nauseous', 'sick', 'green'],
  '🤮': ['vomit', 'puke', 'sick', 'throw up'],
  '🥵': ['hot', 'overheated', 'sweating'],
  '🥶': ['cold', 'freezing', 'frozen'],
  '🥴': ['woozy', 'drunk', 'dizzy'],
  '😵': ['dizzy', 'knocked out', 'dead'],
  '🤯': ['mind blown', 'exploding head', 'wow', 'shocked'],
  '🤠': ['cowboy', 'yeehaw', 'hat'],
  '🥳': ['party', 'celebration', 'birthday', 'celebrate'],
  '🥸': ['disguise', 'incognito', 'glasses'],
  '😎': ['cool', 'sunglasses', 'awesome'],
  '🤓': ['nerd', 'geek', 'glasses'],
  '🧐': ['monocle', 'inspect', 'investigate'],
  '😕': ['confused', 'puzzled'],
  '🫤': ['diagonal mouth', 'unsure', 'meh'],
  '😟': ['worried', 'concerned'],
  '🙁': ['frown', 'sad', 'unhappy'],
  '😮': ['open mouth', 'surprised', 'oh'],
  '😯': ['hushed', 'surprised', 'wow'],
  '😲': ['astonished', 'shocked', 'wow'],
  '😳': ['flushed', 'embarrassed', 'shy'],
  '🥺': ['pleading', 'puppy eyes', 'please', 'begging'],
  '🥹': ['holding back tears', 'emotional', 'touched'],
  '😦': ['frowning', 'open mouth'],
  '😧': ['anguished', 'distressed'],
  '😨': ['fearful', 'scared', 'afraid'],
  '😰': ['anxious', 'nervous', 'cold sweat'],
  '😥': ['sad', 'relieved', 'disappointed'],
  '😢': ['cry', 'crying', 'sad', 'tear'],
  '😭': ['sobbing', 'crying hard', 'bawling', 'sad'],
  '😱': ['scream', 'horror', 'scared', 'omg'],
  '😖': ['confounded', 'frustrated'],
  '😣': ['persevere', 'struggling'],
  '😞': ['disappointed', 'sad'],
  '😓': ['downcast', 'sweat', 'hard work'],
  '😩': ['weary', 'tired', 'exhausted'],
  '😫': ['tired', 'exhausted'],
  '🥱': ['yawn', 'yawning', 'bored', 'sleepy'],
  '😤': ['steam', 'angry', 'frustrated', 'huffing'],
  '😡': ['angry', 'mad', 'rage', 'furious'],
  '😠': ['angry', 'mad', 'grumpy'],
  '🤬': ['swearing', 'cursing', 'angry', 'expletive'],
  '😈': ['devil', 'evil', 'imp'],
  '👿': ['angry devil', 'evil', 'imp'],
  '💀': ['skull', 'dead', 'death', 'skeleton'],
  '☠️': ['skull crossbones', 'danger', 'death', 'poison'],
  '💩': ['poop', 'poo', 'shit', 'crap'],
  '🤡': ['clown', 'silly', 'joker'],
  '👹': ['ogre', 'monster', 'demon'],
  '👺': ['goblin', 'tengu', 'monster'],
  '👻': ['ghost', 'boo', 'spooky', 'halloween'],
  '👽': ['alien', 'ufo', 'extraterrestrial'],
  '👾': ['space invader', 'alien', 'game', 'monster'],
  '🤖': ['robot', 'bot', 'ai'],

  // Gestures & People
  '👋': ['wave', 'hello', 'hi', 'bye', 'waving'],
  '🤚': ['raised hand', 'stop', 'back of hand'],
  '🖐️': ['hand', 'fingers', 'five'],
  '✋': ['high five', 'stop', 'hand'],
  '🖖': ['vulcan', 'spock', 'live long'],
  '👌': ['ok', 'okay', 'perfect', 'nice'],
  '🤌': ['pinched fingers', 'italian', 'chef kiss'],
  '🤏': ['pinching', 'small', 'tiny', 'little'],
  '✌️': ['peace', 'victory', 'v'],
  '🤞': ['fingers crossed', 'luck', 'hope'],
  '🤟': ['love you', 'rock on', 'ily'],
  '🤘': ['rock', 'metal', 'horns'],
  '🤙': ['call me', 'shaka', 'hang loose'],
  '👈': ['point left', 'left'],
  '👉': ['point right', 'right'],
  '👆': ['point up', 'up'],
  '🖕': ['middle finger', 'flip off', 'fu'],
  '👇': ['point down', 'down'],
  '☝️': ['point up', 'one', 'index'],
  '👍': ['thumbs up', 'yes', 'like', 'good', 'approve', '+1'],
  '👎': ['thumbs down', 'no', 'dislike', 'bad', '-1'],
  '✊': ['fist', 'punch', 'power'],
  '👊': ['fist bump', 'punch'],
  '🤛': ['left fist', 'fist bump'],
  '🤜': ['right fist', 'fist bump'],
  '👏': ['clap', 'applause', 'bravo', 'congrats'],
  '🙌': ['raised hands', 'hooray', 'celebrate', 'praise'],
  '🫶': ['heart hands', 'love', 'care'],
  '👐': ['open hands', 'jazz hands'],
  '🤲': ['palms up', 'prayer'],
  '🤝': ['handshake', 'deal', 'agree', 'partnership'],
  '🙏': ['pray', 'please', 'thank you', 'hope', 'namaste', 'thanks'],
  '💪': ['muscle', 'strong', 'flex', 'bicep', 'strength', 'power'],
  '🦾': ['mechanical arm', 'prosthetic', 'robot arm'],

  // Animals & Nature
  '🐶': ['dog', 'puppy', 'pet'],
  '🐱': ['cat', 'kitten', 'pet'],
  '🐭': ['mouse', 'rat'],
  '🐹': ['hamster', 'pet'],
  '🐰': ['rabbit', 'bunny', 'easter'],
  '🦊': ['fox', 'clever'],
  '🐻': ['bear', 'teddy'],
  '🐼': ['panda', 'bear'],
  '🐨': ['koala', 'australia'],
  '🐯': ['tiger', 'cat'],
  '🦁': ['lion', 'king', 'cat'],
  '🐮': ['cow', 'moo'],
  '🐷': ['pig', 'oink'],
  '🐸': ['frog', 'ribbit', 'toad'],
  '🐵': ['monkey', 'ape'],
  '🐔': ['chicken', 'rooster'],
  '🐧': ['penguin', 'bird'],
  '🐦': ['bird', 'tweet'],
  '🦆': ['duck', 'quack'],
  '🦅': ['eagle', 'bird', 'america'],
  '🦉': ['owl', 'night', 'wise'],
  '🦇': ['bat', 'vampire', 'halloween'],
  '🐺': ['wolf', 'howl'],
  '🐗': ['boar', 'pig', 'wild'],
  '🐴': ['horse', 'pony'],
  '🦄': ['unicorn', 'magical', 'fantasy'],
  '🐝': ['bee', 'honey', 'buzz'],
  '🐛': ['bug', 'caterpillar', 'insect'],
  '🦋': ['butterfly', 'beautiful', 'nature'],
  '🐌': ['snail', 'slow'],
  '🐞': ['ladybug', 'bug', 'insect'],
  '🌸': ['cherry blossom', 'flower', 'spring', 'sakura'],
  '💐': ['bouquet', 'flowers', 'gift'],
  '🌷': ['tulip', 'flower', 'spring'],
  '🌹': ['rose', 'flower', 'love', 'romantic'],
  '🌻': ['sunflower', 'flower', 'summer'],
  '🌺': ['hibiscus', 'flower', 'tropical'],
  '🌵': ['cactus', 'desert', 'plant'],
  '🌲': ['evergreen', 'tree', 'pine', 'christmas'],
  '🌳': ['tree', 'deciduous', 'nature'],
  '🍀': ['clover', 'lucky', 'four leaf', 'luck', 'irish'],
  '🍁': ['maple leaf', 'fall', 'autumn', 'canada'],
  '🍂': ['fallen leaf', 'autumn', 'fall'],
  '🍃': ['leaf', 'wind', 'nature'],
  '🪴': ['potted plant', 'houseplant', 'plant'],

  // Food & Drink
  '🍎': ['apple', 'red apple', 'fruit'],
  '🍐': ['pear', 'fruit'],
  '🍊': ['orange', 'tangerine', 'fruit'],
  '🍋': ['lemon', 'citrus', 'sour'],
  '🍌': ['banana', 'fruit'],
  '🍉': ['watermelon', 'fruit', 'summer'],
  '🍇': ['grapes', 'fruit', 'wine'],
  '🍓': ['strawberry', 'fruit', 'berry'],
  '🫐': ['blueberry', 'fruit', 'berry'],
  '🍒': ['cherry', 'cherries', 'fruit'],
  '🍑': ['peach', 'fruit', 'butt'],
  '🥭': ['mango', 'fruit', 'tropical'],
  '🍍': ['pineapple', 'fruit', 'tropical'],
  '🥝': ['kiwi', 'fruit'],
  '🍅': ['tomato', 'vegetable', 'fruit'],
  '🥑': ['avocado', 'guacamole', 'green'],
  '🍕': ['pizza', 'food', 'slice'],
  '🍔': ['burger', 'hamburger', 'food', 'fast food'],
  '🍟': ['fries', 'french fries', 'food', 'fast food'],
  '🌭': ['hot dog', 'food', 'sausage'],
  '🍿': ['popcorn', 'movie', 'snack'],
  '☕': ['coffee', 'tea', 'hot', 'cafe', 'morning'],
  '🍵': ['tea', 'green tea', 'matcha', 'hot'],
  '🍺': ['beer', 'drink', 'cheers', 'pub'],
  '🍻': ['cheers', 'beer', 'toast', 'celebrate'],
  '🥂': ['champagne', 'toast', 'celebrate', 'cheers', 'sparkling'],
  '🍷': ['wine', 'drink', 'red wine'],
  '🍸': ['cocktail', 'martini', 'drink'],
  '🍹': ['tropical drink', 'cocktail'],

  // Activities
  '⚽': ['soccer', 'football', 'sport', 'ball'],
  '🏀': ['basketball', 'sport', 'ball', 'nba'],
  '🏈': ['football', 'american football', 'nfl', 'sport'],
  '⚾': ['baseball', 'sport', 'ball'],
  '🎾': ['tennis', 'sport', 'ball'],
  '🏐': ['volleyball', 'sport'],
  '🎱': ['billiards', 'pool', 'eight ball'],
  '🏓': ['ping pong', 'table tennis'],
  '🎯': ['target', 'bullseye', 'dart', 'goal', 'aim'],
  '🎮': ['video game', 'gaming', 'controller', 'game'],
  '🕹️': ['joystick', 'arcade', 'game'],
  '🎲': ['dice', 'game', 'gambling', 'random', 'chance'],
  '🧩': ['puzzle', 'jigsaw', 'piece'],
  '🎭': ['theater', 'drama', 'masks', 'performing arts'],
  '🎨': ['art', 'paint', 'palette', 'creative', 'design'],
  '🎤': ['microphone', 'sing', 'karaoke', 'mic'],
  '🎧': ['headphones', 'music', 'audio', 'listen'],
  '🎵': ['music', 'note', 'song', 'melody'],

  // Travel & Places
  '🚗': ['car', 'drive', 'automobile', 'vehicle'],
  '🚕': ['taxi', 'cab', 'car'],
  '✈️': ['airplane', 'flight', 'travel', 'plane'],
  '🚀': ['rocket', 'launch', 'space', 'ship', 'fast', 'moon'],
  '🛸': ['ufo', 'alien', 'flying saucer'],
  '🏠': ['house', 'home'],
  '🏢': ['office', 'building', 'work'],
  '🌍': ['earth', 'globe', 'world', 'africa', 'europe'],
  '🌎': ['earth', 'globe', 'world', 'americas'],
  '🌏': ['earth', 'globe', 'world', 'asia'],

  // Objects
  '💻': ['laptop', 'computer', 'coding', 'work', 'dev'],
  '📱': ['phone', 'mobile', 'cell', 'iphone'],
  '⌨️': ['keyboard', 'typing', 'computer'],
  '🖥️': ['desktop', 'computer', 'monitor', 'screen'],
  '💾': ['floppy', 'save', 'disk'],
  '📷': ['camera', 'photo', 'picture'],
  '📞': ['phone', 'telephone', 'call'],
  '📺': ['tv', 'television', 'screen'],
  '🔔': ['bell', 'notification', 'alert', 'ring'],
  '🔕': ['mute', 'silent', 'no bell', 'quiet'],
  '💡': ['lightbulb', 'idea', 'bright', 'light', 'tip'],
  '🔧': ['wrench', 'tool', 'fix', 'settings'],
  '🔨': ['hammer', 'tool', 'build'],
  '📎': ['paperclip', 'attach', 'attachment'],
  '📌': ['pin', 'pushpin', 'location', 'pinned'],
  '📦': ['package', 'box', 'delivery', 'shipping'],

  // Symbols
  '❤️': ['heart', 'love', 'red heart'],
  '🧡': ['orange heart', 'love'],
  '💛': ['yellow heart', 'love'],
  '💚': ['green heart', 'love'],
  '💙': ['blue heart', 'love'],
  '💜': ['purple heart', 'love'],
  '🖤': ['black heart', 'dark', 'love'],
  '🤍': ['white heart', 'love'],
  '🤎': ['brown heart', 'love'],
  '💔': ['broken heart', 'heartbreak', 'sad'],
  '❤️‍🔥': ['heart on fire', 'passion', 'love'],
  '💕': ['two hearts', 'love'],
  '✨': ['sparkles', 'shiny', 'magic', 'new', 'clean', 'stars'],
  '⭐': ['star', 'favorite', 'rating'],
  '🌟': ['glowing star', 'bright', 'excellent'],
  '💫': ['dizzy', 'star', 'shooting star'],
  '🔥': ['fire', 'hot', 'lit', 'flame', 'trending'],
  '💯': ['100', 'hundred', 'perfect', 'score', 'complete'],
  '✅': ['check', 'done', 'yes', 'complete', 'approved', 'correct'],
  '❌': ['x', 'no', 'wrong', 'cross', 'cancel', 'delete', 'remove'],
  '⚠️': ['warning', 'caution', 'alert', 'danger'],
  '🚫': ['no', 'prohibited', 'forbidden', 'banned', 'stop'],
  '♻️': ['recycle', 'green', 'environment'],
  '💤': ['sleep', 'zzz', 'tired', 'snoring'],

  // Flags
  '🏳️': ['white flag', 'surrender'],
  '🏴': ['black flag', 'pirate'],
  '🏁': ['checkered flag', 'race', 'finish'],
  '🚩': ['red flag', 'warning', 'danger', 'triangular flag'],
  '🏳️‍🌈': ['rainbow flag', 'pride', 'lgbtq', 'gay'],
  '🇺🇸': ['usa', 'us', 'america', 'united states'],
  '🇬🇧': ['uk', 'united kingdom', 'britain', 'british'],
  '🇫🇷': ['france', 'french'],
  '🇩🇪': ['germany', 'german'],
  '🇯🇵': ['japan', 'japanese'],
  '🇰🇷': ['korea', 'korean', 'south korea'],
  '🇨🇳': ['china', 'chinese'],
  '🇮🇳': ['india', 'indian'],
  '🇧🇷': ['brazil', 'brazilian'],
  '🇲🇽': ['mexico', 'mexican'],
  '🇨🇦': ['canada', 'canadian'],
  '🇦🇺': ['australia', 'australian'],
  '🇮🇹': ['italy', 'italian'],
  '🇪🇸': ['spain', 'spanish'],
}

export default EMOJI_NAMES
